import { getTheme, Icon, Stack, Text } from '@fluentui/react';
import React, { CSSProperties } from 'react';

interface JsonContentValidationMessageProps {
  message: string;
  validationMessageWrapperClass?: string;
}

export const JsonContentValidationMessage: React.FunctionComponent<JsonContentValidationMessageProps> = (
  props
): JSX.Element => {
  const { palette, fonts } = getTheme();
  const JsonContentValidationMessage: CSSProperties = {
    color: palette.black,
    lineHeight: fonts.large.lineHeight,
    fontFamily: fonts.large.fontFamily,
    fontSize: fonts.large.fontSize
  };

  const IcontStyle: CSSProperties = {
    color: palette.red,
    fontSize: 16,
    lineHeight: '24px'
  };

  return (
    <Stack className={props.validationMessageWrapperClass}>
      <Stack.Item>
        <Icon className="ms-Icon" style={IcontStyle} iconName={'ErrorBadge'} />
      </Stack.Item>
      <Stack.Item>
        <Text style={JsonContentValidationMessage}>{props.message}</Text>
      </Stack.Item>
    </Stack>
  );
};
